import React from 'react';
import { Search, Settings, DollarSign, LineChart, Rocket } from 'lucide-react';
import './Funnel.css';
const ServiceCard = ({ icon: Icon, title, description }) => (
  <div className='service-card'>
    <div className='icon-wrapper'>
      <Icon />
    </div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const services = [
  {
    id: 'funnel-audit',
    icon: Search,
    title: 'Strategy Development',
    description:
      'We begin by conducting a thorough audit of your existing presence, including SEO performance and content quality.',
  },
  {
    id: 'campaign-setup',
    icon: Settings,
    title: 'Optimization and Content Planning',
    description:
      "We craft a detailed SEO strategy and content game plan tailored to your brand's needs that enhances search visibility and audience engagement.",
  },
  {
    id: 'maximize-profit',
    icon: DollarSign,
    title: 'Social Media and Community Building',
    description:
      'Managing your social media accounts to improve interaction through organic posts, Intentional engagement with followers to foster a loyal community.',
  },
  {
    id: 'continuous-optimization',
    icon: LineChart,
    title: 'Launch and Growth Initiatives',
    description:
      'We plan and execute virtual challenges and events to not only engage and expand your audience, but also to drive conversions.',
  },
  // {
  //   id: 'launch-growth',
  //   icon: Rocket,
  //   title: 'Continuous Optimization',
  //   description:
  //     'We continuously monitor the effectiveness of all strategies and campaigns, providing you with detailed reports and insights to maximise organic reach and impact.',
  // },
];

const Funnel = () => {
  return (
    <section>
      <div className='container'>
        <div className='services-grid'>
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Funnel;

/* Funnel.css */
